import KlarnaMessagingViewController from './KlarnaMessagingViewController';

export default KlarnaMessagingViewController;
